'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { CollapsibleContent } from './collapsible-content.component.js';
import { CollapsibleSummaryButton } from './collapsible-summary-button.component.js';
import { CollapsibleSummary } from './collapsible-summary.component.js';
import { Collapsible } from './collapsible.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for(o = 0; o < l.length; o++)r = l[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, l = Object.keys(e);
    for(o = 0; o < l.length; o++)r = l[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let c = {
    heading: e$1.oneOfType([
        e$1.string,
        e$1.element
    ])
}, a = Object.keys(c);
const BasicCollapsible = renderWithRef('BasicCollapsible', c, (e$1, o)=>{
    var { children: c } = e$1, m = _object_without_properties(e$1, [
        "children"
    ]);
    return e.createElement(RenderComp, {
        root: Collapsible,
        forwardedRef: o,
        propKeysToRemove: a,
        props: m
    }, e.createElement(CollapsibleSummary, null, e.createElement(CollapsibleSummaryButton, {
        render: 'string' != typeof m.heading ? (e$1)=>{
            var { children: r } = e$1, o = _object_without_properties(e$1, [
                "children"
            ]);
            return e.createElement("div", _object_spread({
                role: "button",
                tabIndex: 0
            }, o), r);
        } : void 0
    }, m.heading)), e.createElement(CollapsibleContent, null, c));
});

export { BasicCollapsible };
